
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { AdventCountdown } from '@/components/features/advent/AdventCountdown';
import { BaseLayout } from '@/components/templates';
import { Seo } from '@/components/utils/seo/seo-component';
import { OG_IMAGE_URL } from '@/config/urls';
import { Container, Flex, Heading } from '@chakra-ui/react';
import { contentfulClient } from '@cms/client';
import { AdventDaysDocument, AdventDaysQuery } from '@cms/graphql/advent.generated';
import { ComponentAdventCalendarDay } from '@cms/graphql/types.generated';
import { Timeline, TimelineGroupProps } from '@meritcircle/ui/components';
import { addHours, format, isBefore, isWithinInterval } from 'date-fns';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';
import { useEffect } from 'react';
type Props = {
    items: (Omit<ComponentAdventCalendarDay, 'date'> & {
        date: string;
        isActive: boolean;
    })[];
};
const Page = ({ items }: Props) => {
    const { t } = useTranslation('common');
    /* Create timeline groups based on date */
    const timelineGroups: TimelineGroupProps[] = items.reduce((groups: TimelineGroupProps[], { date, isActive, title, description, giveawayUrl }, index) => {
        const existingGroupIndex = groups.findIndex(group => format(new Date(group.date), 'dd-MM') === format(new Date(date), 'dd-MM'));
        if (!!groups[existingGroupIndex]) {
            groups[existingGroupIndex].items.push({
                title,
                description,
                links: giveawayUrl
                    ? [{ label: 'Go to quest', href: giveawayUrl, variant: 'primary' }]
                    : undefined,
                element: isActive && <AdventCountdown date={addHours(new Date(date), 33)}/>
            });
        }
        else {
            groups.push({
                index,
                date,
                isActive,
                items: [
                    {
                        title,
                        description,
                        links: giveawayUrl
                            ? [{ label: 'Go to quest', href: giveawayUrl, variant: 'primary' }]
                            : undefined,
                        element: isActive && <AdventCountdown date={addHours(new Date(date), 33)}/>
                    },
                ],
                onlyHighlightActive: true
            });
        }
        return groups;
    }, []);
    /* Scroll to active day on load */
    useEffect(() => {
        const section = document.querySelector(`#timeline-group-day-${new Date().getDate()}`);
        section?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, []);
    return (<BaseLayout>
      <Seo title="Advent calendar" openGraph={{ images: [{ url: OG_IMAGE_URL, alt: 'BeamHub Logo' }] }}/>
      <Container>
        <Flex flexDir="column" align="center" maxW={rem(900)} mx="auto" py={{ base: '3xl', md: '6xl' }}>
          <Heading as="h1" size="xl" variant="glowing" mb="xl" alignSelf="flex-start">
            Beam Advent Calendar 2024
          </Heading>
          <Timeline w="full" todayLabel={t('date.today')} groups={timelineGroups}/>
        </Flex>
      </Container>
    </BaseLayout>);
};
const getServerSideProps = async () => {
    const { data } = await contentfulClient.query<AdventDaysQuery>(AdventDaysDocument).toPromise();
    const items = data?.componentAdventCalendarDayCollection?.items
        ?.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
        .map(item => {
        const now = new Date();
        const date = new Date(item.date);
        const isActive = isWithinInterval(now, {
            /* Adding 9 hours to 12AM Zulu equals 10am GMT+1 */
            start: addHours(date, 9),
            /* Adding 33 hours to 12AM Zulu equals 10am GMT+1 the next day */
            end: addHours(date, 33)
        });
        return isBefore(addHours(date, 9), now)
            ? { ...item, isActive }
            : {
                title: `Locked until ${format(date, 'MMMM d')}`,
                date: item.date
            };
    });
    if (!items?.length)
        return { notFound: true };
    return { props: { items } };
};
export default Page;

    async function __Next_Translate__getServerSideProps__1973b3b28f2__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/advent/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1973b3b28f2__ as getServerSideProps }
  